export default __webpack_public_path__ + "static/media/My_Resume.a570f517.pdf";